import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon, Image } from "react-bootstrap";
import { format } from 'date-fns';
const renderRow = (review, onEdit, isReadOnly, onDelete) => {
    const imageUrl = `api/settings/reviews/image/${review.ReviewImgId}?t=${new Date().getTime()}`;
    return (
        <tr key={review.Id}>
            <td><Image src={imageUrl} height="50" /></td>
            <td>{review.Id}</td>
            <td>{review.UserName}</td>
            <td>{review.Description}</td>
            <td>{review.Source}</td>
            <td>{format(new Date(review.TimeAndZone ), 'DD.MM.YYYY')}</td>
            <td>
                <Glyphicon 
                    glyph='trash' 
                    className={`glyphicon-trash${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onDelete(review)} 
                    title='Удалить' />
            </td>
            <td>
                <Glyphicon 
                    glyph='pencil' 
                    className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onEdit(review)} 
                    title='Изменить' />
            </td>
        </tr>
    );
};
export const Table = ({ reviews, fetching, onEdit, isReadOnly, onDelete }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>Скрин отзыва</td>
                        <td>№</td>
                        <td>Имя пользователя</td>
                        <td>Описание</td>
                        <td>Источник</td>
                        <td>Дата публикации</td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {reviews.map(d => renderRow(d, onEdit, isReadOnly, onDelete))}
                </tbody>
            </table>}
    </div>
);


// WEBPACK FOOTER //
// ./src/components/settings/reviews/Table.jsx